const ef_menuTrigger = document.querySelector(".ef-header__hamburger");
const ef_header = document.querySelector(".ef-header");
const ef_scrollUp = "--scroll-up";
const ef_scrollDown = "--scroll-down";
let ef_lastScroll = 0;

if (ef_menuTrigger && ef_header) {
  // Show/hide header on scroll
  window.addEventListener("scroll", () => {
    let currentScroll = window.pageYOffset;

    if (currentScroll <= 128) {
      ef_header.classList.remove(ef_scrollUp);
      ef_menuTrigger.classList.remove(ef_scrollUp);
      ef_header.classList.remove(ef_scrollDown);
      ef_menuTrigger.classList.remove(ef_scrollDown);
      return;
    }

    if (currentScroll > 128) {
      if (currentScroll > ef_lastScroll && !ef_header.classList.contains(ef_scrollDown)) {
        // Scroll nach unten
        ef_header.classList.remove(ef_scrollUp);
        ef_header.classList.add(ef_scrollDown);
        ef_menuTrigger.classList.remove(ef_scrollUp);
        ef_menuTrigger.classList.add(ef_scrollDown);
      } else if (currentScroll < ef_lastScroll && ef_header.classList.contains(ef_scrollDown)) {
        // Scroll nach oben
        ef_header.classList.remove(ef_scrollDown);
        ef_header.classList.add(ef_scrollUp);
        ef_menuTrigger.classList.remove(ef_scrollDown);
        ef_menuTrigger.classList.add(ef_scrollUp);
      }
      ef_lastScroll = currentScroll;
    }
  });
}
